import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { authRequest } from '../../store/modules/auth/actions';
import history from '../../services/history';
import './styles.css';

function Login() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  
  useEffect(() => {
    if (isAuthenticated) history.push('/');
  }, [isAuthenticated]);

  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');

  const handleSubmit = async(e) => {
    e.preventDefault();
    dispatch(authRequest(usuario, senha));
  };

  return (
    <form className="login" onSubmit={handleSubmit}>
      <div className="field">
        <p className="control has-icons-left has-icons-right">
          <input className="input" placeholder="Usuário" value={usuario} onChange={e => setUsuario(e.target.value)} />
          <span className="icon is-small is-left">
            <i className="fas fa-user"></i>
          </span>
          {/* <span className="icon is-small is-right">
            <i className="fas fa-check"></i>
          </span> */}
        </p>
      </div>
      <div className="field">
        <p className="control has-icons-left">
          <input className="input" type="password" placeholder="Senha" value={senha} onChange={e => setSenha(e.target.value)} />
          <span className="icon is-small is-left">
            <i className="fas fa-lock"></i>
          </span>
        </p>
      </div>
      <div className="field is-grouped">
        <p className="control">
          <button className="button is-success" type="submit">
            Login
          </button>
        </p>
        <p className="control">
          <Link to={`/cadastro`} className="button is-light">Cadastrar</Link>
        </p>
      </div>
    </form>
  );
}

export default Login;